import {
  AlertTriangle, ClipboardCheck, Droplets, Flame, Lightbulb, Paintbrush, Plug, ShowerHead, Snowflake, Sun,
  Thermometer, Wind, Wrench, Zap, type LucideIcon,
} from 'lucide-react';

/**
 * The picture on a service tile when the owner has not put one there.
 *
 * Avenue's form sells with a photo per service; ours draws a trade icon from
 * the service's own name so a fresh account's page is not a wall of identical
 * tiles. Once the owner uploads a picture in the wizard it wins. First match
 * wins, most specific first: "emergency boiler" is an emergency, not a boiler.
 *
 * Directive-free: the public page renders it in the browser and the wizard's
 * editor previews it (CLAUDE.md #18).
 */
/**
 * Each rule carries the icon AND the stock photo in `public/booking/tiles/`
 * (14 generated 23 Sep 2026, 512px WebP, ~380KB the lot). The photo is what a
 * fresh account's page shows; the icon is the wizard's thumbnail and the
 * fallback if a tile ever fails to load.
 */
const RULES: [RegExp, LucideIcon, string][] = [
  [/emergenc|urgent|call.?out|24\/?7|out of hours/i, AlertTriangle, 'emergency'],
  [/cp12|landlord|gas safe|certificate|cert\b|inspection|eicr|safety check/i, ClipboardCheck, 'certificate'],
  [/boiler|combi|heating|radiator|thermostat/i, Flame, 'boiler'],
  [/air.?con|aircon|a\/c|cooling|heat pump/i, Snowflake, 'aircon'],
  [/solar|pv\b|panel/i, Sun, 'solar'],
  [/bathroom|shower|bath\b|toilet|wc\b/i, ShowerHead, 'bathroom'],
  [/leak|drip|tap\b|drain|blocked|pipe|plumb|water/i, Droplets, 'plumbing'],
  [/light|lamp|spot|downlight/i, Lightbulb, 'lighting'],
  [/socket|fuse|consumer unit|rewire|switch|electric|ev charger|charger/i, Zap, 'electrics'],
  [/extractor|ventilat|fan\b|duct/i, Wind, 'ventilation'],
  [/immersion|cylinder|hot water/i, Thermometer, 'hot-water'],
  [/paint|decorat|plaster/i, Paintbrush, 'decorating'],
  [/appliance|cooker|hob|oven|install/i, Plug, 'appliance'],
];

export function serviceIcon(name: string): LucideIcon {
  for (const [re, icon] of RULES) if (re.test(name)) return icon;
  return Wrench;
}

/** The stock tile for a service with no picture of its own. Always a URL: the general one otherwise. */
export function serviceStockPhoto(name: string): string {
  for (const [re, , key] of RULES) if (re.test(name)) return `/booking/tiles/${key}.webp`;
  return '/booking/tiles/general.webp';
}
